
import { computed, ref } from "vue";
import * as yup from "yup";
import useLocale from "@/core/common/useLocale";
import { ErrorMessage, Field, Form } from "vee-validate";

export default {
  name: "NoMedicalRecordsForm",
  components: { ErrorMessage, Field, Form },
  emits: ["submitForm"],

  setup(props, { emit }) {
    const { t } = useLocale();

    const hospitalName = ref("");
    const cityState = ref("");
    const physicianName = ref("");

    const isFormFilled = computed(() => {
      return !!(hospitalName.value && cityState.value && physicianName.value);
    });

    const validationSchema = yup.object({
      hospital_name: yup
        .string()
        .matches(
          /^([^0-9+-]*)$/,
          t("Only alphabets are allowed for this field")
        )
        .required(t("Hospital name is a required field"))
        .label(t("Hospital name")),
      hospital_location: yup
        .string()
        .required(t("Location is a required field"))
        .label(t("Hospital Location")),
      physician_name: yup
        .string()
        .matches(
          /^([^0-9+-]*)$/,
          t("Only alphabets are allowed for this field")
        )
        .required(t("Physician Name is a required field"))
        .label(t("Physician Name")),
    });

    function onSubmit(values) {
      emit("submitForm", values);
    }

    return {
      hospitalName,
      cityState,
      physicianName,
      isFormFilled,
      validationSchema,
      onSubmit,
    };
  },
};
